import * as actionTypes from './actionTypes'

import { getListingIndex } from '../../helpers/utils'
import { enqueueSnackbar } from './alert'
import kpiTypeAxios from '../../axios/kpiType'

export const fetchKpiType = filterOptions => {
  return dispatch => {
    const params = {
      ...filterOptions,
      page: filterOptions ? filterOptions.page : 1,
      perPage: filterOptions ? filterOptions.perPage : 10
    }

    dispatch(fetchKpiTypeStart())

    kpiTypeAxios
      .get('', { params })
      .then(response => {
        if (response.status === 200 && response.data.success) {
          const { current_page, from, last_page, per_page, to, total, data } = response.data.data

          const pagination = {
            currentPage: current_page,
            lastPage: last_page,
            perPage: per_page,
            from,
            to,
            total
          }

          const dataWithOption = data.map((item, index) => {
            return { ...item, index: getListingIndex(index, per_page, current_page) }
          })

          dispatch(fetchKpiTypeSuccess(pagination, dataWithOption))
        }
      })
      .catch(error => {
        dispatch(fetchKpiTypeFailed(error))
      })
  }
}

export const fetchKpiTypeStart = () => {
  return {
    type: actionTypes.FETCH_KPI_TYPE_START
  }
}

export const fetchKpiTypeSuccess = (pagination, records) => {
  return {
    type: actionTypes.FETCH_KPI_TYPE_SUCCESS,
    pagination,
    records
  }
}

export const fetchKpiTypeFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_KPI_TYPE_FAILED,
    errorMessage
  }
}

export const fetchKpiTypeById = recordId => {
  return dispatch => {
    dispatch(fetchKpiTypeStart())
    kpiTypeAxios
      .get(`/${recordId}`)
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchKpiTypeByIdSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchKpiTypeFailed(error))
      })
  }
}

export const fetchKpiTypeByIdSuccess = recordData => {
  return {
    type: actionTypes.FETCH_KPI_TYPE_BY_ID_SUCCESS,
    recordData
  }
}

export const clearSelectedKpiTypeRecord = () => {
  return {
    type: actionTypes.CLEAR_SELECTED_KPI_TYPE_RECORD
  }
}

export const createKpiType = (recordData, page) => {
  return dispatch => {
    dispatch(createKpiTypeStart())

    kpiTypeAxios
      .post('', recordData)
      .then(response => {
        if (response.status === 201) {
          dispatch(
            enqueueSnackbar({
              message: 'Kpi Type Created',
              options: {
                variant: 'success'
              }
            })
          )
          dispatch(createKpiTypeSuccess())
          dispatch(fetchKpiType(page))
        }
      })
      .catch(error => {
        switch (error.response.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'Invalid Kpi Type field',
                options: {
                  variant: 'error',
                  data: error.response.data.data
                }
              })
            )
            break

          default:
            dispatch(
              enqueueSnackbar({
                message: error.response.data.message,
                options: {
                  variant: 'error'
                }
              })
            )
            break
        }
        dispatch(createKpiTypeFailed())
      })
  }
}

export const createKpiTypeStart = () => {
  return {
    type: actionTypes.CREATE_KPI_TYPE_START
  }
}

export const createKpiTypeSuccess = () => {
  return {
    type: actionTypes.CREATE_KPI_TYPE_SUCCESS
  }
}

export const createKpiTypeFailed = () => {
  return {
    type: actionTypes.CREATE_KPI_TYPE_FAILED
  }
}

export const updateKpiType = (recordId, recordData, page) => {
  return dispatch => {
    dispatch(updateKpiTypeStart())

    kpiTypeAxios
      .patch(`/${recordId}`, recordData)
      .then(response => {
        dispatch(
          enqueueSnackbar({
            message: 'Kpi Type Updated',
            options: {
              variant: 'success'
            }
          })
        )
        dispatch(updateKpiTypeSuccess())
        dispatch(fetchKpiType(page))
      })
      .catch(error => {
        switch (error.response.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'Invalid Kpi Type field',
                options: {
                  variant: 'error',
                  data: error.response.data.data
                }
              })
            )
            break

          default:
            dispatch(
              enqueueSnackbar({
                message: error.response.data.message,
                options: {
                  variant: 'error'
                }
              })
            )
            break
        }
        dispatch(updateKpiTypeFailed())
      })
  }
}

export const updateKpiTypeStart = () => {
  return {
    type: actionTypes.UPDATE_KPI_TYPE_START
  }
}

export const updateKpiTypeSuccess = () => {
  return {
    type: actionTypes.UPDATE_KPI_TYPE_SUCCESS
  }
}

export const updateKpiTypeFailed = () => {
  return {
    type: actionTypes.UPDATE_KPI_TYPE_FAILED
  }
}

export const deleteKpiType = (recordId, page) => {
  return dispatch => {
    dispatch(deleteKpiTypeStart())
    kpiTypeAxios
      .delete(`/${recordId}`)
      .then(response => {
        dispatch(
          enqueueSnackbar({
            message: 'Kpi Type Deleted',
            options: {
              key: recordId,
              variant: 'success'
            }
          })
        )
        dispatch(deleteKpiTypeSuccess())
        dispatch(fetchKpiType(page))
      })
      .catch(error => {
        dispatch(
          enqueueSnackbar({
            message: error.response.data.message,
            options: {
              variant: 'error'
            }
          })
        )
        dispatch(deleteKpiTypeFailed())
      })
  }
}

export const deleteKpiTypeStart = () => {
  return {
    type: actionTypes.DELETE_KPI_TYPE_START
  }
}

export const deleteKpiTypeSuccess = () => {
  return {
    type: actionTypes.DELETE_KPI_TYPE_SUCCESS
  }
}

export const deleteKpiTypeFailed = () => {
  return {
    type: actionTypes.DELETE_KPI_TYPE_FAILED
  }
}
